(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    function initGarantiePopup() {
      var modal = document.querySelector('#garantie-label-modal');
      var trigger = document.querySelector('.garantie-label-trigger');

      if (!modal || !trigger || modal.dataset.garantieInitialized === 'true') {
        return;
      }

      modal.dataset.garantieInitialized = 'true';

      var closeElements = modal.querySelectorAll('[data-garantie-close]');

      function openModal() {
        modal.hidden = false;
        document.body.classList.add('garantie-modal-open');
      }

      function closeModal() {
        modal.hidden = true;
        document.body.classList.remove('garantie-modal-open');
        trigger.focus();
      }

      trigger.addEventListener('click', openModal);

      closeElements.forEach(function (element) {
        element.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !modal.hidden) {
          closeModal();
        }
      });
    }

    initGarantiePopup();

    document.addEventListener('shopify:section:load', function () {
      initGarantiePopup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
